export enum AuthMethod {
  OAUTH = 'oauth',
  SBA = 'single booking access',
}
